import { Component } from '@angular/core';

import { InterestForm } from '../app-launcher.models';
import { AppLauncherStateService } from '../app-launcher-state.service';

@Component({
	selector: 'sd-expanded-access',
	templateUrl: './expanded-access.component.html',
})
export class ExpandedAccessComponent {
	public form: InterestForm = {
		...this.state.interestForm,
		email: this.state.accountEmail,
	};

	constructor(public readonly state: AppLauncherStateService) {}

	public submit(): void {
		this.state.submitInterest(this.form);
	}

	public returnToApp(): void {
		this.state.goTo('create-app');
	}
}
